import axios, { AxiosResponse } from "axios";
import { GetPaidInitialData } from "types/get_paid";
import { sanitizeGetPaidData } from "helpers/get_paid";

export async function getGetPaidInitialData() {
  const response = await axios.get<GetPaidInitialData[]>(`/tenant/integrations/tahseel.json`);
  const data = sanitizeGetPaidData(response.data);
  return data;
}

export async function postGetPaidForm(formData: FormData): Promise<AxiosResponse<any>> {
  const csrfToken =
    document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";
  const response = await axios.post(`/tenant/integrations/install_qpay`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "text/javascript",
      "X-CSRF-Token": csrfToken,
    },
  });
  return response.data as AxiosResponse<any>;
}
